export default "__VITE_ASSET__BCEYs4BD__"